import { userConstants } from "../../constants/ActionTypes";

const initialState = {
    openBulkTrans:false,
    list:[],
    transpin:"",
    file_upload:"",
    transpinText:false,
    page : 1,
    limit : 10, 
    disabled_page:true,
    showMpin:false,
};

export function bulkUpload(state = initialState, action) {
    switch (action.type) {  
        case userConstants.BULKUPLOAD:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}